import { render, staticRenderFns } from "./RoadKing.vue?vue&type=template&id=a77052a8&scoped=true&"
import script from "./RoadKing.vue?vue&type=script&lang=js&"
export * from "./RoadKing.vue?vue&type=script&lang=js&"
import style0 from "./RoadKing.vue?vue&type=style&index=0&id=a77052a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77052a8",
  null
  
)

export default component.exports